import ShieldLockIcon from '@mdi/svg/svg/shield-lock-outline.svg?react';
import ShieldOffIcon from '@mdi/svg/svg/shield-off-outline.svg?react';
import { MDIIcon } from '@solinkcorp/solink-components';
import { Card, CardContent, cn } from '@solinkcorp/solink-ui';
import { type VirtualTabletAction } from 'clients/VirtualTabletApi';
import React from 'react';
import useLocale from 'src/hooks/useLocale';
import ArmingCountdown from './ArmingCountdown';
import { CARD_MAX_WIDTH_CLASS, STEP_CARD_MIN_HEIGHT_CLASS } from './constants';

interface SuccessStatusProps {
  action: VirtualTabletAction;
  armingSecondsRemaining: number;
  armingTotalSeconds: number;
}

const SuccessStatus: React.FC<SuccessStatusProps> = ({
  action,
  armingSecondsRemaining,
  armingTotalSeconds,
}) => {
  const locale = useLocale();
  const isArmed = action === 'arm';
  const isCountingDown = isArmed && armingSecondsRemaining > 0;

  return (
    <Card
      className={cn(CARD_MAX_WIDTH_CLASS, STEP_CARD_MIN_HEIGHT_CLASS)}
      data-testid="success-message"
    >
      <CardContent className="flex flex-col items-center gap-2">
        {isCountingDown ? (
          <>
            <ArmingCountdown
              secondsRemaining={armingSecondsRemaining}
              totalSeconds={armingTotalSeconds}
            />
            <span className="text-status-orange heading-md">
              {locale.virtualTablet.armingMessage}
            </span>
          </>
        ) : (
          <>
            {isArmed ? (
              <MDIIcon
                icon={ShieldLockIcon}
                size={32}
                className="fill-current text-status-orange"
              />
            ) : (
              <MDIIcon
                icon={ShieldOffIcon}
                size={32}
                className="fill-current text-foreground-green"
              />
            )}
            <span
              className={cn('heading-md', isArmed ? 'text-status-orange' : 'text-foreground-green')}
            >
              {isArmed ? locale.alarms.armed : locale.alarms.disarmed}
            </span>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default SuccessStatus;
